import React from 'react'
import { Router } from '@reach/router'
import Main from './Main'
import Permissions from './Permissions'

function UserManagement() {
  return (
    <Router>
      <Main path="/" />
      <Permissions path=":userId/permissions" />
    </Router>
  )
}

export default UserManagement
